import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _31256153 = () => interopDefault(import('../../../pages/metals.vue' /* webpackChunkName: "pages/metals" */))
const _6fb896c4 = () => interopDefault(import('../../../pages/collections.vue' /* webpackChunkName: "pages/collections" */))
const _dc33cb08 = () => interopDefault(import('../../../pages/configurator.vue' /* webpackChunkName: "pages/configurator" */))
const _2f301934 = () => interopDefault(import('../../../pages/diamonds.vue' /* webpackChunkName: "pages/diamonds" */))
const _08271a1b = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _babc2bfc = () => interopDefault(import('../../../pages/engraving.vue' /* webpackChunkName: "pages/engraving" */))
const _2703bc70 = () => interopDefault(import('../../../pages/memoireRings.vue' /* webpackChunkName: "pages/memoireRings" */))
const _33a09192 = () => interopDefault(import('../../../pages/imprint.vue' /* webpackChunkName: "pages/imprint" */))
const _520d80dd = () => interopDefault(import('../../../pages/diamondJewelry.vue' /* webpackChunkName: "pages/diamondJewelry" */))
const _88206ff4 = () => interopDefault(import('../../../pages/shops.vue' /* webpackChunkName: "pages/shops" */))
const _7a784187 = () => interopDefault(import('../../../pages/shoplogout.vue' /* webpackChunkName: "pages/shoplogout" */))
const _6904da4a = () => interopDefault(import('../../../pages/magazine.vue' /* webpackChunkName: "pages/magazine" */))
const _42c5a489 = () => interopDefault(import('../../../pages/memoireRingsFullSizeMemoires.vue' /* webpackChunkName: "pages/memoireRingsFullSizeMemoires" */))
const _3b9135b0 = () => interopDefault(import('../../../pages/memoireRingsGrowingMemoires.vue' /* webpackChunkName: "pages/memoireRingsGrowingMemoires" */))
const _bce9fe20 = () => interopDefault(import('../../../pages/onlineConsulting.vue' /* webpackChunkName: "pages/onlineConsulting" */))
const _2f218154 = () => interopDefault(import('../../../pages/about.vue' /* webpackChunkName: "pages/about" */))
const _3974bcde = () => interopDefault(import('../../../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _6f55bafd = () => interopDefault(import('../../../pages/consulting.vue' /* webpackChunkName: "pages/consulting" */))
const _3e541d0b = () => interopDefault(import('../../../pages/ringSizes.vue' /* webpackChunkName: "pages/ringSizes" */))
const _0d85adee = () => interopDefault(import('../../../pages/sapphire.vue' /* webpackChunkName: "pages/sapphire" */))
const _77240700 = () => interopDefault(import('../../../pages/shopIndividualBeBrussels.vue' /* webpackChunkName: "pages/shopIndividualBeBrussels" */))
const _09846784 = () => interopDefault(import('../../../pages/sitemap.vue' /* webpackChunkName: "pages/sitemap" */))
const _478dee2e = () => interopDefault(import('../../../pages/styles.vue' /* webpackChunkName: "pages/styles" */))
const _338d3295 = () => interopDefault(import('../../../pages/sweepstake.vue' /* webpackChunkName: "pages/sweepstake" */))
const _20c38596 = () => interopDefault(import('../../../pages/weddingRings.vue' /* webpackChunkName: "pages/weddingRings" */))
const _7ce9486a = () => interopDefault(import('../../../pages/urbanMining.vue' /* webpackChunkName: "pages/urbanMining" */))
const _c821c6e8 = () => interopDefault(import('../../../pages/wishlist.vue' /* webpackChunkName: "pages/wishlist" */))
const _e065bb66 = () => interopDefault(import('../../../pages/engagementRings.vue' /* webpackChunkName: "pages/engagementRings" */))
const _661ec2be = () => interopDefault(import('../../../pages/zweiklang.vue' /* webpackChunkName: "pages/zweiklang" */))
const _651b55f6 = () => interopDefault(import('../../../pages/zweiklangConfigurator.vue' /* webpackChunkName: "pages/zweiklangConfigurator" */))
const _02d8a97d = () => interopDefault(import('../../../pages/aboutPackaging.vue' /* webpackChunkName: "pages/aboutPackaging" */))
const _04ccc8a5 = () => interopDefault(import('../../../pages/aboutRjc.vue' /* webpackChunkName: "pages/aboutRjc" */))
const _1da5e3d0 = () => interopDefault(import('../../../pages/configuratorV2.vue' /* webpackChunkName: "pages/configuratorV2" */))
const _282633ae = () => interopDefault(import('../../../pages/engagementRingsHalo.vue' /* webpackChunkName: "pages/engagementRingsHalo" */))
const _10849445 = () => interopDefault(import('../../../pages/engagementRingsTensionRing.vue' /* webpackChunkName: "pages/engagementRingsTensionRing" */))
const _2f36ed5c = () => interopDefault(import('../../../pages/engravingFonts.vue' /* webpackChunkName: "pages/engravingFonts" */))
const _029232b8 = () => interopDefault(import('../../../pages/engravingInspiration.vue' /* webpackChunkName: "pages/engravingInspiration" */))
const _5481e5ec = () => interopDefault(import('../../../pages/engravingSayings.vue' /* webpackChunkName: "pages/engravingSayings" */))
const _2fb2b029 = () => interopDefault(import('../../../pages/engravingSymbols.vue' /* webpackChunkName: "pages/engravingSymbols" */))
const _402c32cb = () => interopDefault(import('../../../pages/memoireRingsBestseller.vue' /* webpackChunkName: "pages/memoireRingsBestseller" */))
const _41d4ecef = () => interopDefault(import('../../../pages/memoireRingsBudgetHigh.vue' /* webpackChunkName: "pages/memoireRingsBudgetHigh" */))
const _3b948397 = () => interopDefault(import('../../../pages/memoireRingsBudgetLow.vue' /* webpackChunkName: "pages/memoireRingsBudgetLow" */))
const _0a76e402 = () => interopDefault(import('../../../pages/memoireRingsBudgetMedium.vue' /* webpackChunkName: "pages/memoireRingsBudgetMedium" */))
const _03ce4697 = () => interopDefault(import('../../../pages/memoireRingsCheap.vue' /* webpackChunkName: "pages/memoireRingsCheap" */))
const _7a11f38a = () => interopDefault(import('../../../pages/memoireRingsColored.vue' /* webpackChunkName: "pages/memoireRingsColored" */))
const _06328370 = () => interopDefault(import('../../../pages/memoireRingsGold.vue' /* webpackChunkName: "pages/memoireRingsGold" */))
const _1951f014 = () => interopDefault(import('../../../pages/memoireRingsHalfSetMemories.vue' /* webpackChunkName: "pages/memoireRingsHalfSetMemories" */))
const _29391214 = () => interopDefault(import('../../../pages/memoireRingsPlatinum.vue' /* webpackChunkName: "pages/memoireRingsPlatinum" */))
const _34ac5d39 = () => interopDefault(import('../../../pages/memoireRingsRedgold.vue' /* webpackChunkName: "pages/memoireRingsRedgold" */))
const _6c894ed2 = () => interopDefault(import('../../../pages/memoireRingsRosegold.vue' /* webpackChunkName: "pages/memoireRingsRosegold" */))
const _e8fa802e = () => interopDefault(import('../../../pages/memoireRingsRingsets.vue' /* webpackChunkName: "pages/memoireRingsRingsets" */))
const _4e930600 = () => interopDefault(import('../../../pages/memoireRingsSignature.vue' /* webpackChunkName: "pages/memoireRingsSignature" */))
const _382270a5 = () => interopDefault(import('../../../pages/memoireRingsSlim.vue' /* webpackChunkName: "pages/memoireRingsSlim" */))
const _091b52c6 = () => interopDefault(import('../../../pages/memoireRingsConfigurator.vue' /* webpackChunkName: "pages/memoireRingsConfigurator" */))
const _342bc8e6 = () => interopDefault(import('../../../pages/memoireRingsExclusive.vue' /* webpackChunkName: "pages/memoireRingsExclusive" */))
const _45bbda09 = () => interopDefault(import('../../../pages/memoireRingsAsWeddingRings.vue' /* webpackChunkName: "pages/memoireRingsAsWeddingRings" */))
const _e6de1e1e = () => interopDefault(import('../../../pages/memoireRingsWhite.vue' /* webpackChunkName: "pages/memoireRingsWhite" */))
const _446cce69 = () => interopDefault(import('../../../pages/diamondJewelrySignet.vue' /* webpackChunkName: "pages/diamondJewelrySignet" */))
const _fcac239e = () => interopDefault(import('../../../pages/diamondJewelry025Carat.vue' /* webpackChunkName: "pages/diamondJewelry025Carat" */))
const _7ae8d0d9 = () => interopDefault(import('../../../pages/diamondJewelry050Carat.vue' /* webpackChunkName: "pages/diamondJewelry050Carat" */))
const _b69b934a = () => interopDefault(import('../../../pages/diamondJewelry070Carat.vue' /* webpackChunkName: "pages/diamondJewelry070Carat" */))
const _cbba0f1a = () => interopDefault(import('../../../pages/diamondJewelry100Carat.vue' /* webpackChunkName: "pages/diamondJewelry100Carat" */))
const _3ebfbebe = () => interopDefault(import('../../../pages/diamondJewelryBracelets.vue' /* webpackChunkName: "pages/diamondJewelryBracelets" */))
const _54137ba0 = () => interopDefault(import('../../../pages/diamondJewelryBestseller.vue' /* webpackChunkName: "pages/diamondJewelryBestseller" */))
const _55bc35c4 = () => interopDefault(import('../../../pages/diamondJewelryBudgetHigh.vue' /* webpackChunkName: "pages/diamondJewelryBudgetHigh" */))
const _1c3367bc = () => interopDefault(import('../../../pages/diamondJewelryBudgetLow.vue' /* webpackChunkName: "pages/diamondJewelryBudgetLow" */))
const _7ca168d2 = () => interopDefault(import('../../../pages/diamondJewelryBudgetMedium.vue' /* webpackChunkName: "pages/diamondJewelryBudgetMedium" */))
const _48dcbf58 = () => interopDefault(import('../../../pages/diamondJewelryCollectionRings.vue' /* webpackChunkName: "pages/diamondJewelryCollectionRings" */))
const _9aaa839c = () => interopDefault(import('../../../pages/diamondJewelryConfigurator.vue' /* webpackChunkName: "pages/diamondJewelryConfigurator" */))
const _77fd0aba = () => interopDefault(import('../../../pages/diamondJewelryDelicateJewels.vue' /* webpackChunkName: "pages/diamondJewelryDelicateJewels" */))
const _5ce91c2a = () => interopDefault(import('../../../pages/diamondJewelryEarrings.vue' /* webpackChunkName: "pages/diamondJewelryEarrings" */))
const _756190c6 = () => interopDefault(import('../../../pages/diamondJewelryColliers.vue' /* webpackChunkName: "pages/diamondJewelryColliers" */))
const _2b04dd1e = () => interopDefault(import('../../../pages/diamondJewelryExclusive.vue' /* webpackChunkName: "pages/diamondJewelryExclusive" */))
const _3ed68add = () => interopDefault(import('../../../pages/diamondJewelryGold.vue' /* webpackChunkName: "pages/diamondJewelryGold" */))
const _1e968c29 = () => interopDefault(import('../../../pages/diamondJewelryPlatinum.vue' /* webpackChunkName: "pages/diamondJewelryPlatinum" */))
const _555ccc84 = () => interopDefault(import('../../../pages/diamondJewelryRedgold.vue' /* webpackChunkName: "pages/diamondJewelryRedgold" */))
const _81ce5aa8 = () => interopDefault(import('../../../pages/diamondJewelryRosegold.vue' /* webpackChunkName: "pages/diamondJewelryRosegold" */))
const _1ae07a4e = () => interopDefault(import('../../../pages/diamondJewelrySets.vue' /* webpackChunkName: "pages/diamondJewelrySets" */))
const _04e4ce8b = () => interopDefault(import('../../../pages/diamondJewelrySignature.vue' /* webpackChunkName: "pages/diamondJewelrySignature" */))
const _5db3355c = () => interopDefault(import('../../../pages/diamondJewelryWhitegold.vue' /* webpackChunkName: "pages/diamondJewelryWhitegold" */))
const _eb803dc6 = () => interopDefault(import('../../../pages/aboutSustainability.vue' /* webpackChunkName: "pages/aboutSustainability" */))
const _623b9632 = () => interopDefault(import('../../../pages/aboutPhilosophy.vue' /* webpackChunkName: "pages/aboutPhilosophy" */))
const _6572820a = () => interopDefault(import('../../../pages/aboutJewelryManufacturing.vue' /* webpackChunkName: "pages/aboutJewelryManufacturing" */))
const _044bc579 = () => interopDefault(import('../../../pages/aboutQuality.vue' /* webpackChunkName: "pages/aboutQuality" */))
const _32c27098 = () => interopDefault(import('../../../pages/aboutDesign.vue' /* webpackChunkName: "pages/aboutDesign" */))
const _9a8dffa2 = () => interopDefault(import('../../../pages/aboutService.vue' /* webpackChunkName: "pages/aboutService" */))
const _50620b20 = () => interopDefault(import('../../../pages/aboutWeddingRingManufacturing.vue' /* webpackChunkName: "pages/aboutWeddingRingManufacturing" */))
const _f4a66126 = () => interopDefault(import('../../../pages/ringSizesCalculator.vue' /* webpackChunkName: "pages/ringSizesCalculator" */))
const _72a6c69a = () => interopDefault(import('../../../pages/ringSizesTable.vue' /* webpackChunkName: "pages/ringSizesTable" */))
const _8c4a62c2 = () => interopDefault(import('../../../pages/stylesIndividualStyle.vue' /* webpackChunkName: "pages/stylesIndividualStyle" */))
const _3cbfa6b9 = () => interopDefault(import('../../../pages/weddingRingsBlack.vue' /* webpackChunkName: "pages/weddingRingsBlack" */))
const _7bd4d892 = () => interopDefault(import('../../../pages/weddingRingsFinishes.vue' /* webpackChunkName: "pages/weddingRingsFinishes" */))
const _394ca5ce = () => interopDefault(import('../../../pages/weddingRingsBestseller.vue' /* webpackChunkName: "pages/weddingRingsBestseller" */))
const _c222d2c0 = () => interopDefault(import('../../../pages/weddingRingsForestGreen.vue' /* webpackChunkName: "pages/weddingRingsForestGreen" */))
const _35fb3186 = () => interopDefault(import('../../../pages/weddingRingsBudgetHigh.vue' /* webpackChunkName: "pages/weddingRingsBudgetHigh" */))
const _0270f0ee = () => interopDefault(import('../../../pages/weddingRingsBudgetLow.vue' /* webpackChunkName: "pages/weddingRingsBudgetLow" */))
const _cfa1fa60 = () => interopDefault(import('../../../pages/weddingRingsBudgetMedium.vue' /* webpackChunkName: "pages/weddingRingsBudgetMedium" */))
const _a857abba = () => interopDefault(import('../../../pages/weddingRingsCarbon.vue' /* webpackChunkName: "pages/weddingRingsCarbon" */))
const _34e3ea5e = () => interopDefault(import('../../../pages/weddingRingsCertificate.vue' /* webpackChunkName: "pages/weddingRingsCertificate" */))
const _edab152a = () => interopDefault(import('../../../pages/weddingRingsConfigurator.vue' /* webpackChunkName: "pages/weddingRingsConfigurator" */))
const _472d9371 = () => interopDefault(import('../../../pages/weddingRingsCrown.vue' /* webpackChunkName: "pages/weddingRingsCrown" */))
const _38351dd5 = () => interopDefault(import('../../../pages/weddingRingsDiamonds.vue' /* webpackChunkName: "pages/weddingRingsDiamonds" */))
const _51847efe = () => interopDefault(import('../../../pages/weddingRingsGayLesbianCouples.vue' /* webpackChunkName: "pages/weddingRingsGayLesbianCouples" */))
const _11426650 = () => interopDefault(import('../../../pages/weddingRingsExclusive.vue' /* webpackChunkName: "pages/weddingRingsExclusive" */))
const _70ca7efa = () => interopDefault(import('../../../pages/weddingRingsFancy.vue' /* webpackChunkName: "pages/weddingRingsFancy" */))
const _5c85a0ea = () => interopDefault(import('../../../pages/weddingRingsFrameSettings.vue' /* webpackChunkName: "pages/weddingRingsFrameSettings" */))
const _62e51304 = () => interopDefault(import('../../../pages/weddingRingsPlain.vue' /* webpackChunkName: "pages/weddingRingsPlain" */))
const _01f51389 = () => interopDefault(import('../../../pages/weddingRingsCheap.vue' /* webpackChunkName: "pages/weddingRingsCheap" */))
const _05198b16 = () => interopDefault(import('../../../pages/weddingRingsGold.vue' /* webpackChunkName: "pages/weddingRingsGold" */))
const _339385a3 = () => interopDefault(import('../../../pages/weddingRingsHearts.vue' /* webpackChunkName: "pages/weddingRingsHearts" */))
const _291c6d4c = () => interopDefault(import('../../../pages/weddingRingsClassic.vue' /* webpackChunkName: "pages/weddingRingsClassic" */))
const _0b7b7990 = () => interopDefault(import('../../../pages/weddingRingsMen.vue' /* webpackChunkName: "pages/weddingRingsMen" */))
const _04b7eb1a = () => interopDefault(import('../../../pages/weddingRingsMillgrif.vue' /* webpackChunkName: "pages/weddingRingsMillgrif" */))
const _47f16ed5 = () => interopDefault(import('../../../pages/weddingRingsModern.vue' /* webpackChunkName: "pages/weddingRingsModern" */))
const _4bd2dd0b = () => interopDefault(import('../../../pages/weddingRingsMokumeGane.vue' /* webpackChunkName: "pages/weddingRingsMokumeGane" */))
const _0e7cc7e2 = () => interopDefault(import('../../../pages/weddingRingsPlatinum.vue' /* webpackChunkName: "pages/weddingRingsPlatinum" */))
const _74a0d9d7 = () => interopDefault(import('../../../pages/weddingRingsRingSets.vue' /* webpackChunkName: "pages/weddingRingsRingSets" */))
const _4453b5ab = () => interopDefault(import('../../../pages/weddingRingsRedgold.vue' /* webpackChunkName: "pages/weddingRingsRedgold" */))
const _a201e336 = () => interopDefault(import('../../../pages/weddingRingsRosegold.vue' /* webpackChunkName: "pages/weddingRingsRosegold" */))
const _32ff2130 = () => interopDefault(import('../../../pages/weddingRingsSecretHeart.vue' /* webpackChunkName: "pages/weddingRingsSecretHeart" */))
const _11c609f2 = () => interopDefault(import('../../../pages/weddingRingsSignature.vue' /* webpackChunkName: "pages/weddingRingsSignature" */))
const _40553d73 = () => interopDefault(import('../../../pages/weddingRingsSlim.vue' /* webpackChunkName: "pages/weddingRingsSlim" */))
const _6da2287a = () => interopDefault(import('../../../pages/weddingRingsStackingRings.vue' /* webpackChunkName: "pages/weddingRingsStackingRings" */))
const _ee91f8fc = () => interopDefault(import('../../../pages/weddingRingsStarrySky.vue' /* webpackChunkName: "pages/weddingRingsStarrySky" */))
const _fadf5972 = () => interopDefault(import('../../../pages/weddingRingsTensionRings.vue' /* webpackChunkName: "pages/weddingRingsTensionRings" */))
const _33ce4c56 = () => interopDefault(import('../../../pages/weddingRingstrisets.vue' /* webpackChunkName: "pages/weddingRingstrisets" */))
const _aa377bd4 = () => interopDefault(import('../../../pages/weddingRingsTwoColors.vue' /* webpackChunkName: "pages/weddingRingsTwoColors" */))
const _1c5f0738 = () => interopDefault(import('../../../pages/weddingRingsWomen.vue' /* webpackChunkName: "pages/weddingRingsWomen" */))
const _7058aacd = () => interopDefault(import('../../../pages/weddingRingsWaveDesign.vue' /* webpackChunkName: "pages/weddingRingsWaveDesign" */))
const _6a9470c3 = () => interopDefault(import('../../../pages/weddingRingsWhitegold.vue' /* webpackChunkName: "pages/weddingRingsWhitegold" */))
const _78291fa1 = () => interopDefault(import('../../../pages/engagementRings025Carat.vue' /* webpackChunkName: "pages/engagementRings025Carat" */))
const _71680249 = () => interopDefault(import('../../../pages/engagementRings050Carat.vue' /* webpackChunkName: "pages/engagementRings050Carat" */))
const _c99d306a = () => interopDefault(import('../../../pages/engagementRings070Carat.vue' /* webpackChunkName: "pages/engagementRings070Carat" */))
const _debbac3a = () => interopDefault(import('../../../pages/engagementRings100Carat.vue' /* webpackChunkName: "pages/engagementRings100Carat" */))
const _b0e7dde0 = () => interopDefault(import('../../../pages/engagementRingsBestseller.vue' /* webpackChunkName: "pages/engagementRingsBestseller" */))
const _65011c77 = () => interopDefault(import('../../../pages/engagementRingsDiamond.vue' /* webpackChunkName: "pages/engagementRingsDiamond" */))
const _ad966998 = () => interopDefault(import('../../../pages/engagementRingsBudgetHigh.vue' /* webpackChunkName: "pages/engagementRingsBudgetHigh" */))
const _69656e9c = () => interopDefault(import('../../../pages/engagementRingsBudgetLow.vue' /* webpackChunkName: "pages/engagementRingsBudgetLow" */))
const _19584507 = () => interopDefault(import('../../../pages/engagementRingsBudgetMedium.vue' /* webpackChunkName: "pages/engagementRingsBudgetMedium" */))
const _317b3696 = () => interopDefault(import('../../../pages/engagementRingsClassic.vue' /* webpackChunkName: "pages/engagementRingsClassic" */))
const _61980fe8 = () => interopDefault(import('../../../pages/engagementRingsCollectionRings.vue' /* webpackChunkName: "pages/engagementRingsCollectionRings" */))
const _0a53b7a2 = () => interopDefault(import('../../../pages/engagementRingsConfigurator.vue' /* webpackChunkName: "pages/engagementRingsConfigurator" */))
const _43cbf8d8 = () => interopDefault(import('../../../pages/engagementRingsDainty.vue' /* webpackChunkName: "pages/engagementRingsDainty" */))
const _3ece138c = () => interopDefault(import('../../../pages/engagementRingsDiamonds.vue' /* webpackChunkName: "pages/engagementRingsDiamonds" */))
const _7836e3fe = () => interopDefault(import('../../../pages/engagementRingsExclusive.vue' /* webpackChunkName: "pages/engagementRingsExclusive" */))
const _7b0d03a8 = () => interopDefault(import('../../../pages/engagementRingsFancy.vue' /* webpackChunkName: "pages/engagementRingsFancy" */))
const _6807f44d = () => interopDefault(import('../../../pages/engagementRingsGold.vue' /* webpackChunkName: "pages/engagementRingsGold" */))
const _17af6dae = () => interopDefault(import('../../../pages/engagementRingsHeart.vue' /* webpackChunkName: "pages/engagementRingsHeart" */))
const _ae2b3368 = () => interopDefault(import('../../../pages/engagementRingsModern.vue' /* webpackChunkName: "pages/engagementRingsModern" */))
const _1515bd99 = () => interopDefault(import('../../../pages/engagementRingsPlatinum.vue' /* webpackChunkName: "pages/engagementRingsPlatinum" */))
const _6cae9656 = () => interopDefault(import('../../../pages/engagementRingsPrincess.vue' /* webpackChunkName: "pages/engagementRingsPrincess" */))
const _0279ad14 = () => interopDefault(import('../../../pages/engagementRingsRedgold.vue' /* webpackChunkName: "pages/engagementRingsRedgold" */))
const _94cff7c8 = () => interopDefault(import('../../../pages/engagementRingsRosegold.vue' /* webpackChunkName: "pages/engagementRingsRosegold" */))
const _436869ca = () => interopDefault(import('../../../pages/engagementRingsSignature.vue' /* webpackChunkName: "pages/engagementRingsSignature" */))
const _001114f9 = () => interopDefault(import('../../../pages/engagementRingsSolitaire.vue' /* webpackChunkName: "pages/engagementRingsSolitaire" */))
const _4b3c78c9 = () => interopDefault(import('../../../pages/engagementRingsVintage.vue' /* webpackChunkName: "pages/engagementRingsVintage" */))
const _371a31ec = () => interopDefault(import('../../../pages/engagementRingsWhitegold.vue' /* webpackChunkName: "pages/engagementRingsWhitegold" */))
const _6f29ad60 = () => interopDefault(import('../../../pages/weddingRingsCeramic.vue' /* webpackChunkName: "pages/weddingRingsCeramic" */))
const _11cf63df = () => interopDefault(import('../../../pages/weddingRingsFacetes.vue' /* webpackChunkName: "pages/weddingRingsFacetes" */))
const _24f6daf3 = () => interopDefault(import('../../../pages/weddingRingsFacettedConnections.vue' /* webpackChunkName: "pages/weddingRingsFacettedConnections" */))
const _681bebab = () => interopDefault(import('../../../pages/weddingRingsMorningGlow.vue' /* webpackChunkName: "pages/weddingRingsMorningGlow" */))
const _450a5071 = () => interopDefault(import('../../../pages/weddingRingsNaturalBeige.vue' /* webpackChunkName: "pages/weddingRingsNaturalBeige" */))
const _5a028310 = () => interopDefault(import('../../../pages/weddingRingsPolar.vue' /* webpackChunkName: "pages/weddingRingsPolar" */))
const _3586822f = () => interopDefault(import('../../../pages/aboutPlantMyTree.vue' /* webpackChunkName: "pages/aboutPlantMyTree" */))
const _36e702ff = () => interopDefault(import('../../../pages/diamondJewelryPresentsYearly.vue' /* webpackChunkName: "pages/diamondJewelryPresentsYearly" */))
const _4ec8fdc6 = () => interopDefault(import('../../../pages/diamondJewelryPresentsChristmas.vue' /* webpackChunkName: "pages/diamondJewelryPresentsChristmas" */))
const _26857eb8 = () => interopDefault(import('../../../pages/diamondJewelryPresentsMother.vue' /* webpackChunkName: "pages/diamondJewelryPresentsMother" */))
const _64722111 = () => interopDefault(import('../../../pages/diamondJewelryPresentsValentine.vue' /* webpackChunkName: "pages/diamondJewelryPresentsValentine" */))
const _3c1b1119 = () => interopDefault(import('../../../pages/diamondJewelryPresentsWomen.vue' /* webpackChunkName: "pages/diamondJewelryPresentsWomen" */))
const _2fde0a01 = () => interopDefault(import('../../../pages/weddingRingsStylesCool.vue' /* webpackChunkName: "pages/weddingRingsStylesCool" */))
const _2c62d767 = () => interopDefault(import('../../../pages/weddingRingsStylesCreative.vue' /* webpackChunkName: "pages/weddingRingsStylesCreative" */))
const _56dac0b6 = () => interopDefault(import('../../../pages/weddingRingsStylesElegant.vue' /* webpackChunkName: "pages/weddingRingsStylesElegant" */))
const _906cb876 = () => interopDefault(import('../../../pages/weddingRingsStylesLuxury.vue' /* webpackChunkName: "pages/weddingRingsStylesLuxury" */))
const _428b54be = () => interopDefault(import('../../../pages/weddingRingsStylesNatural.vue' /* webpackChunkName: "pages/weddingRingsStylesNatural" */))
const _43bb4829 = () => interopDefault(import('../../../pages/weddingRingsStylesRomantic.vue' /* webpackChunkName: "pages/weddingRingsStylesRomantic" */))
const _9d75356c = () => interopDefault(import('../../../pages/weddingRingsStylesUrban.vue' /* webpackChunkName: "pages/weddingRingsStylesUrban" */))
const _f844d58a = () => interopDefault(import('../../../pages/_item.vue' /* webpackChunkName: "pages/_item" */))
const _74184f26 = () => interopDefault(import('../../../pages/_shopsDetails.vue' /* webpackChunkName: "pages/_shopsDetails" */))
const _3d323f8a = () => interopDefault(import('../../../pages/_shoplogin.vue' /* webpackChunkName: "pages/_shoplogin" */))
const _252755c5 = () => interopDefault(import('../../../pages/_wishlistDetails.vue' /* webpackChunkName: "pages/_wishlistDetails" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/alloys/",
    component: _31256153,
    pathToRegexpOptions: {"strict":true},
    name: "metals___nl"
  }, {
    path: "/collecties/",
    component: _6fb896c4,
    pathToRegexpOptions: {"strict":true},
    name: "collections___nl"
  }, {
    path: "/configurator/",
    component: _dc33cb08,
    pathToRegexpOptions: {"strict":true},
    name: "configurator___nl"
  }, {
    path: "/diamanten/",
    component: _2f301934,
    pathToRegexpOptions: {"strict":true},
    name: "diamonds___nl"
  }, {
    path: "/en/",
    component: _08271a1b,
    pathToRegexpOptions: {"strict":true},
    name: "index___en"
  }, {
    path: "/engraving/",
    component: _babc2bfc,
    pathToRegexpOptions: {"strict":true},
    name: "engraving___nl"
  }, {
    path: "/eternity-rings/",
    component: _2703bc70,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRings___nl"
  }, {
    path: "/imprint/",
    component: _33a09192,
    pathToRegexpOptions: {"strict":true},
    name: "imprint___nl"
  }, {
    path: "/juwelen/",
    component: _520d80dd,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelry___nl"
  }, {
    path: "/locatie/",
    component: _88206ff4,
    pathToRegexpOptions: {"strict":true},
    name: "shops___nl"
  }, {
    path: "/logout/",
    component: _7a784187,
    pathToRegexpOptions: {"strict":true},
    name: "shoplogout___nl"
  }, {
    path: "/magazine/",
    component: _6904da4a,
    pathToRegexpOptions: {"strict":true},
    name: "magazine___nl"
  }, {
    path: "/memoireRingsFullSizeMemoires/",
    component: _42c5a489,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsFullSizeMemoires___nl"
  }, {
    path: "/memoireRingsGrowingMemoires/",
    component: _3b9135b0,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsGrowingMemoires___nl"
  }, {
    path: "/online-consultation/",
    component: _bce9fe20,
    pathToRegexpOptions: {"strict":true},
    name: "onlineConsulting___nl"
  }, {
    path: "/over-acredo/",
    component: _2f218154,
    pathToRegexpOptions: {"strict":true},
    name: "about___nl"
  }, {
    path: "/privacy/",
    component: _3974bcde,
    pathToRegexpOptions: {"strict":true},
    name: "privacy___nl"
  }, {
    path: "/raadpleging/",
    component: _6f55bafd,
    pathToRegexpOptions: {"strict":true},
    name: "consulting___nl"
  }, {
    path: "/ringmaat/",
    component: _3e541d0b,
    pathToRegexpOptions: {"strict":true},
    name: "ringSizes___nl"
  }, {
    path: "/sapphire/",
    component: _0d85adee,
    pathToRegexpOptions: {"strict":true},
    name: "sapphire___nl"
  }, {
    path: "/shopIndividualBeBrussels/",
    component: _77240700,
    pathToRegexpOptions: {"strict":true},
    name: "shopIndividualBeBrussels___nl"
  }, {
    path: "/sitemap/",
    component: _09846784,
    pathToRegexpOptions: {"strict":true},
    name: "sitemap___nl"
  }, {
    path: "/stijlen/",
    component: _478dee2e,
    pathToRegexpOptions: {"strict":true},
    name: "styles___nl"
  }, {
    path: "/sweepstake/",
    component: _338d3295,
    pathToRegexpOptions: {"strict":true},
    name: "sweepstake___nl"
  }, {
    path: "/trouwringen/",
    component: _20c38596,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRings___nl"
  }, {
    path: "/urban-mining/",
    component: _7ce9486a,
    pathToRegexpOptions: {"strict":true},
    name: "urbanMining___nl"
  }, {
    path: "/verlanglijstje/",
    component: _c821c6e8,
    pathToRegexpOptions: {"strict":true},
    name: "wishlist___nl"
  }, {
    path: "/verlovingsringen/",
    component: _e065bb66,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRings___nl"
  }, {
    path: "/zweiklang/",
    component: _661ec2be,
    pathToRegexpOptions: {"strict":true},
    name: "zweiklang___nl"
  }, {
    path: "/zweiklangConfigurator/",
    component: _651b55f6,
    pathToRegexpOptions: {"strict":true},
    name: "zweiklangConfigurator___nl"
  }, {
    path: "/about-acredo/packaging/",
    component: _02d8a97d,
    pathToRegexpOptions: {"strict":true},
    name: "aboutPackaging___nl"
  }, {
    path: "/about-acredo/rjc-certification/",
    component: _04ccc8a5,
    pathToRegexpOptions: {"strict":true},
    name: "aboutRjc___nl"
  }, {
    path: "/configurator/basic/",
    component: _1da5e3d0,
    pathToRegexpOptions: {"strict":true},
    name: "configuratorV2___nl"
  }, {
    path: "/en/about-acredo/",
    component: _2f218154,
    pathToRegexpOptions: {"strict":true},
    name: "about___en"
  }, {
    path: "/en/alloys/",
    component: _31256153,
    pathToRegexpOptions: {"strict":true},
    name: "metals___en"
  }, {
    path: "/en/collections/",
    component: _6fb896c4,
    pathToRegexpOptions: {"strict":true},
    name: "collections___en"
  }, {
    path: "/en/configurator/",
    component: _dc33cb08,
    pathToRegexpOptions: {"strict":true},
    name: "configurator___en"
  }, {
    path: "/en/consultation/",
    component: _6f55bafd,
    pathToRegexpOptions: {"strict":true},
    name: "consulting___en"
  }, {
    path: "/en/diamonds/",
    component: _2f301934,
    pathToRegexpOptions: {"strict":true},
    name: "diamonds___en"
  }, {
    path: "/en/engagement-rings/",
    component: _e065bb66,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRings___en"
  }, {
    path: "/en/engraving/",
    component: _babc2bfc,
    pathToRegexpOptions: {"strict":true},
    name: "engraving___en"
  }, {
    path: "/en/eternity-rings/",
    component: _2703bc70,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRings___en"
  }, {
    path: "/en/imprint/",
    component: _33a09192,
    pathToRegexpOptions: {"strict":true},
    name: "imprint___en"
  }, {
    path: "/en/jewelry/",
    component: _520d80dd,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelry___en"
  }, {
    path: "/en/location/",
    component: _88206ff4,
    pathToRegexpOptions: {"strict":true},
    name: "shops___en"
  }, {
    path: "/en/logout/",
    component: _7a784187,
    pathToRegexpOptions: {"strict":true},
    name: "shoplogout___en"
  }, {
    path: "/en/magazine/",
    component: _6904da4a,
    pathToRegexpOptions: {"strict":true},
    name: "magazine___en"
  }, {
    path: "/en/memoireRingsFullSizeMemoires/",
    component: _42c5a489,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsFullSizeMemoires___en"
  }, {
    path: "/en/memoireRingsGrowingMemoires/",
    component: _3b9135b0,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsGrowingMemoires___en"
  }, {
    path: "/en/online-consultation/",
    component: _bce9fe20,
    pathToRegexpOptions: {"strict":true},
    name: "onlineConsulting___en"
  }, {
    path: "/en/privacy/",
    component: _3974bcde,
    pathToRegexpOptions: {"strict":true},
    name: "privacy___en"
  }, {
    path: "/en/ringsize/",
    component: _3e541d0b,
    pathToRegexpOptions: {"strict":true},
    name: "ringSizes___en"
  }, {
    path: "/en/sapphire/",
    component: _0d85adee,
    pathToRegexpOptions: {"strict":true},
    name: "sapphire___en"
  }, {
    path: "/en/shopIndividualBeBrussels/",
    component: _77240700,
    pathToRegexpOptions: {"strict":true},
    name: "shopIndividualBeBrussels___en"
  }, {
    path: "/en/sitemap/",
    component: _09846784,
    pathToRegexpOptions: {"strict":true},
    name: "sitemap___en"
  }, {
    path: "/en/styles/",
    component: _478dee2e,
    pathToRegexpOptions: {"strict":true},
    name: "styles___en"
  }, {
    path: "/en/sweepstake/",
    component: _338d3295,
    pathToRegexpOptions: {"strict":true},
    name: "sweepstake___en"
  }, {
    path: "/en/urban-mining/",
    component: _7ce9486a,
    pathToRegexpOptions: {"strict":true},
    name: "urbanMining___en"
  }, {
    path: "/en/wedding-rings/",
    component: _20c38596,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRings___en"
  }, {
    path: "/en/wishlist/",
    component: _c821c6e8,
    pathToRegexpOptions: {"strict":true},
    name: "wishlist___en"
  }, {
    path: "/en/zweiklang/",
    component: _661ec2be,
    pathToRegexpOptions: {"strict":true},
    name: "zweiklang___en"
  }, {
    path: "/engagement-rings/halo/",
    component: _282633ae,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsHalo___nl"
  }, {
    path: "/engagment-rings/tension/",
    component: _10849445,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsTensionRing___nl"
  }, {
    path: "/engraving/fonts/",
    component: _2f36ed5c,
    pathToRegexpOptions: {"strict":true},
    name: "engravingFonts___nl"
  }, {
    path: "/engraving/inspiration/",
    component: _029232b8,
    pathToRegexpOptions: {"strict":true},
    name: "engravingInspiration___nl"
  }, {
    path: "/engraving/sayings/",
    component: _5481e5ec,
    pathToRegexpOptions: {"strict":true},
    name: "engravingSayings___nl"
  }, {
    path: "/engraving/symbols/",
    component: _2fb2b029,
    pathToRegexpOptions: {"strict":true},
    name: "engravingSymbols___nl"
  }, {
    path: "/eternity-rings/bestseller/",
    component: _402c32cb,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsBestseller___nl"
  }, {
    path: "/eternity-rings/budget-hoog/",
    component: _41d4ecef,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsBudgetHigh___nl"
  }, {
    path: "/eternity-rings/budget-laag/",
    component: _3b948397,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsBudgetLow___nl"
  }, {
    path: "/eternity-rings/budget-medium/",
    component: _0a76e402,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsBudgetMedium___nl"
  }, {
    path: "/eternity-rings/cheap/",
    component: _03ce4697,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsCheap___nl"
  }, {
    path: "/eternity-rings/colored/",
    component: _7a11f38a,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsColored___nl"
  }, {
    path: "/eternity-rings/gold/",
    component: _06328370,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsGold___nl"
  }, {
    path: "/eternity-rings/half-summarized/",
    component: _1951f014,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsHalfSetMemories___nl"
  }, {
    path: "/eternity-rings/platinum/",
    component: _29391214,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsPlatinum___nl"
  }, {
    path: "/eternity-rings/rood-goud/",
    component: _34ac5d39,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsRedgold___nl"
  }, {
    path: "/eternity-rings/rosegold/",
    component: _6c894ed2,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsRosegold___nl"
  }, {
    path: "/eternity-rings/sets/",
    component: _e8fa802e,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsRingsets___nl"
  }, {
    path: "/eternity-rings/signature/",
    component: _4e930600,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsSignature___nl"
  }, {
    path: "/eternity-rings/till-005-carat/",
    component: _382270a5,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsSlim___nl"
  }, {
    path: "/eternity-rings/till-010-carat/",
    component: _091b52c6,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsConfigurator___nl"
  }, {
    path: "/eternity-rings/till-025-carat/",
    component: _342bc8e6,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsExclusive___nl"
  }, {
    path: "/eternity-rings/trouwringen/",
    component: _45bbda09,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsAsWeddingRings___nl"
  }, {
    path: "/eternity-rings/wit-goud/",
    component: _e6de1e1e,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsWhite___nl"
  }, {
    path: "/jewelry/signet/",
    component: _446cce69,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelrySignet___nl"
  }, {
    path: "/juwelen/025-carat/",
    component: _fcac239e,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelry025Carat___nl"
  }, {
    path: "/juwelen/05-carat/",
    component: _7ae8d0d9,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelry050Carat___nl"
  }, {
    path: "/juwelen/07-carat/",
    component: _b69b934a,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelry070Carat___nl"
  }, {
    path: "/juwelen/1-carat/",
    component: _cbba0f1a,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelry100Carat___nl"
  }, {
    path: "/juwelen/armbanden/",
    component: _3ebfbebe,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryBracelets___nl"
  }, {
    path: "/juwelen/bestseller/",
    component: _54137ba0,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryBestseller___nl"
  }, {
    path: "/juwelen/budget-hoog/",
    component: _55bc35c4,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryBudgetHigh___nl"
  }, {
    path: "/juwelen/budget-laag/",
    component: _1c3367bc,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryBudgetLow___nl"
  }, {
    path: "/juwelen/budget-medium/",
    component: _7ca168d2,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryBudgetMedium___nl"
  }, {
    path: "/juwelen/collectie-ringen/",
    component: _48dcbf58,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryCollectionRings___nl"
  }, {
    path: "/juwelen/configurator/",
    component: _9aaa839c,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryConfigurator___nl"
  }, {
    path: "/juwelen/delicate-sets/",
    component: _77fd0aba,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryDelicateJewels___nl"
  }, {
    path: "/juwelen/diamant-oorbellen/",
    component: _5ce91c2a,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryEarrings___nl"
  }, {
    path: "/juwelen/diamanten_halsketting/",
    component: _756190c6,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryColliers___nl"
  }, {
    path: "/juwelen/exclusief/",
    component: _2b04dd1e,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryExclusive___nl"
  }, {
    path: "/juwelen/goud/",
    component: _3ed68add,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryGold___nl"
  }, {
    path: "/juwelen/platin/",
    component: _1e968c29,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryPlatinum___nl"
  }, {
    path: "/juwelen/rood-goud/",
    component: _555ccc84,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryRedgold___nl"
  }, {
    path: "/juwelen/rosegold/",
    component: _81ce5aa8,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryRosegold___nl"
  }, {
    path: "/juwelen/sets/",
    component: _1ae07a4e,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelrySets___nl"
  }, {
    path: "/juwelen/signature/",
    component: _04e4ce8b,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelrySignature___nl"
  }, {
    path: "/juwelen/wit-goud/",
    component: _5db3355c,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryWhitegold___nl"
  }, {
    path: "/over-acredo/duurzaamheid/",
    component: _eb803dc6,
    pathToRegexpOptions: {"strict":true},
    name: "aboutSustainability___nl"
  }, {
    path: "/over-acredo/filosofie/",
    component: _623b9632,
    pathToRegexpOptions: {"strict":true},
    name: "aboutPhilosophy___nl"
  }, {
    path: "/over-acredo/juwelenproductie/",
    component: _6572820a,
    pathToRegexpOptions: {"strict":true},
    name: "aboutJewelryManufacturing___nl"
  }, {
    path: "/over-acredo/kwaliteit/",
    component: _044bc579,
    pathToRegexpOptions: {"strict":true},
    name: "aboutQuality___nl"
  }, {
    path: "/over-acredo/ontwerp/",
    component: _32c27098,
    pathToRegexpOptions: {"strict":true},
    name: "aboutDesign___nl"
  }, {
    path: "/over-acredo/service/",
    component: _9a8dffa2,
    pathToRegexpOptions: {"strict":true},
    name: "aboutService___nl"
  }, {
    path: "/over-acredo/trouwringen-productie/",
    component: _50620b20,
    pathToRegexpOptions: {"strict":true},
    name: "aboutWeddingRingManufacturing___nl"
  }, {
    path: "/ringmaat/calculator/",
    component: _f4a66126,
    pathToRegexpOptions: {"strict":true},
    name: "ringSizesCalculator___nl"
  }, {
    path: "/ringmaat/chart/",
    component: _72a6c69a,
    pathToRegexpOptions: {"strict":true},
    name: "ringSizesTable___nl"
  }, {
    path: "/stijlen/uw-individuele-stijl/",
    component: _8c4a62c2,
    pathToRegexpOptions: {"strict":true},
    name: "stylesIndividualStyle___nl"
  }, {
    path: "/trouwringe/zwart/",
    component: _3cbfa6b9,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsBlack___nl"
  }, {
    path: "/trouwringen/afwerkingen/",
    component: _7bd4d892,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsFinishes___nl"
  }, {
    path: "/trouwringen/bestseller/",
    component: _394ca5ce,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsBestseller___nl"
  }, {
    path: "/trouwringen/bos_groen/",
    component: _c222d2c0,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsForestGreen___nl"
  }, {
    path: "/trouwringen/budget-hoog/",
    component: _35fb3186,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsBudgetHigh___nl"
  }, {
    path: "/trouwringen/budget-laag/",
    component: _0270f0ee,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsBudgetLow___nl"
  }, {
    path: "/trouwringen/budget-medium/",
    component: _cfa1fa60,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsBudgetMedium___nl"
  }, {
    path: "/trouwringen/carbon/",
    component: _a857abba,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsCarbon___nl"
  }, {
    path: "/trouwringen/certificaat/",
    component: _34e3ea5e,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsCertificate___nl"
  }, {
    path: "/trouwringen/configurator/",
    component: _edab152a,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsConfigurator___nl"
  }, {
    path: "/trouwringen/crown/",
    component: _472d9371,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsCrown___nl"
  }, {
    path: "/trouwringen/diamanten/",
    component: _38351dd5,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsDiamonds___nl"
  }, {
    path: "/trouwringen/diversiteit/",
    component: _51847efe,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsGayLesbianCouples___nl"
  }, {
    path: "/trouwringen/exclusief/",
    component: _11426650,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsExclusive___nl"
  }, {
    path: "/trouwringen/fancy/",
    component: _70ca7efa,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsFancy___nl"
  }, {
    path: "/trouwringen/frame-instellingen/",
    component: _5c85a0ea,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsFrameSettings___nl"
  }, {
    path: "/trouwringen/gewoon/",
    component: _62e51304,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsPlain___nl"
  }, {
    path: "/trouwringen/goedkoop/",
    component: _01f51389,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsCheap___nl"
  }, {
    path: "/trouwringen/goud/",
    component: _05198b16,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsGold___nl"
  }, {
    path: "/trouwringen/hartje/",
    component: _339385a3,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsHearts___nl"
  }, {
    path: "/trouwringen/klassiek/",
    component: _291c6d4c,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsClassic___nl"
  }, {
    path: "/trouwringen/mannen/",
    component: _0b7b7990,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsMen___nl"
  }, {
    path: "/trouwringen/milgrain/",
    component: _04b7eb1a,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsMillgrif___nl"
  }, {
    path: "/trouwringen/modern/",
    component: _47f16ed5,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsModern___nl"
  }, {
    path: "/trouwringen/mokume-gane/",
    component: _4bd2dd0b,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsMokumeGane___nl"
  }, {
    path: "/trouwringen/platinum/",
    component: _0e7cc7e2,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsPlatinum___nl"
  }, {
    path: "/trouwringen/ring-sets/",
    component: _74a0d9d7,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsRingSets___nl"
  }, {
    path: "/trouwringen/rose-goud/",
    component: _4453b5ab,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsRedgold___nl"
  }, {
    path: "/trouwringen/rose-goud/",
    component: _a201e336,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsRosegold___nl"
  }, {
    path: "/trouwringen/secret-heart/",
    component: _32ff2130,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsSecretHeart___nl"
  }, {
    path: "/trouwringen/signature/",
    component: _11c609f2,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsSignature___nl"
  }, {
    path: "/trouwringen/slank/",
    component: _40553d73,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsSlim___nl"
  }, {
    path: "/trouwringen/stapel-ringen/",
    component: _6da2287a,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStackingRings___nl"
  }, {
    path: "/trouwringen/starry_skies/",
    component: _ee91f8fc,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStarrySky___nl"
  }, {
    path: "/trouwringen/tension/",
    component: _fadf5972,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsTensionRings___nl"
  }, {
    path: "/trouwringen/trisets/",
    component: _33ce4c56,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingstrisets___nl"
  }, {
    path: "/trouwringen/twee_kleuren/",
    component: _aa377bd4,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsTwoColors___nl"
  }, {
    path: "/trouwringen/vrouwen/",
    component: _1c5f0738,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsWomen___nl"
  }, {
    path: "/trouwringen/wave/",
    component: _7058aacd,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsWaveDesign___nl"
  }, {
    path: "/trouwringen/wit-goud/",
    component: _6a9470c3,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsWhitegold___nl"
  }, {
    path: "/verlovingsringen/025-carat/",
    component: _78291fa1,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRings025Carat___nl"
  }, {
    path: "/verlovingsringen/05-carat/",
    component: _71680249,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRings050Carat___nl"
  }, {
    path: "/verlovingsringen/07-carat/",
    component: _c99d306a,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRings070Carat___nl"
  }, {
    path: "/verlovingsringen/1-carat/",
    component: _debbac3a,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRings100Carat___nl"
  }, {
    path: "/verlovingsringen/bestseller/",
    component: _b0e7dde0,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsBestseller___nl"
  }, {
    path: "/verlovingsringen/brillant/",
    component: _65011c77,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsDiamond___nl"
  }, {
    path: "/verlovingsringen/budget-hoog/",
    component: _ad966998,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsBudgetHigh___nl"
  }, {
    path: "/verlovingsringen/budget-laag/",
    component: _69656e9c,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsBudgetLow___nl"
  }, {
    path: "/verlovingsringen/budget-medium/",
    component: _19584507,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsBudgetMedium___nl"
  }, {
    path: "/verlovingsringen/classic/",
    component: _317b3696,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsClassic___nl"
  }, {
    path: "/verlovingsringen/collectie-ringen/",
    component: _61980fe8,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsCollectionRings___nl"
  }, {
    path: "/verlovingsringen/configurator/",
    component: _0a53b7a2,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsConfigurator___nl"
  }, {
    path: "/verlovingsringen/dainty/",
    component: _43cbf8d8,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsDainty___nl"
  }, {
    path: "/verlovingsringen/diamanten/",
    component: _3ece138c,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsDiamonds___nl"
  }, {
    path: "/verlovingsringen/exclusief/",
    component: _7836e3fe,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsExclusive___nl"
  }, {
    path: "/verlovingsringen/fancy/",
    component: _7b0d03a8,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsFancy___nl"
  }, {
    path: "/verlovingsringen/goud/",
    component: _6807f44d,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsGold___nl"
  }, {
    path: "/verlovingsringen/hart-ringen/",
    component: _17af6dae,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsHeart___nl"
  }, {
    path: "/verlovingsringen/modern/",
    component: _ae2b3368,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsModern___nl"
  }, {
    path: "/verlovingsringen/platinum/",
    component: _1515bd99,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsPlatinum___nl"
  }, {
    path: "/verlovingsringen/princess/",
    component: _6cae9656,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsPrincess___nl"
  }, {
    path: "/verlovingsringen/rood-goud/",
    component: _0279ad14,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsRedgold___nl"
  }, {
    path: "/verlovingsringen/rose-gold/",
    component: _94cff7c8,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsRosegold___nl"
  }, {
    path: "/verlovingsringen/signature/",
    component: _436869ca,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsSignature___nl"
  }, {
    path: "/verlovingsringen/solitaire/",
    component: _001114f9,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsSolitaire___nl"
  }, {
    path: "/verlovingsringen/vintage/",
    component: _4b3c78c9,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsVintage___nl"
  }, {
    path: "/verlovingsringen/wit-goud/",
    component: _371a31ec,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsWhitegold___nl"
  }, {
    path: "/wedding-rings/ceramic/",
    component: _6f29ad60,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsCeramic___nl"
  }, {
    path: "/wedding-rings/facetes/",
    component: _11cf63df,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsFacetes___nl"
  }, {
    path: "/wedding-rings/facetted-connections/",
    component: _24f6daf3,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsFacettedConnections___nl"
  }, {
    path: "/wedding-rings/morning-glow/",
    component: _681bebab,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsMorningGlow___nl"
  }, {
    path: "/wedding-rings/natural-beige/",
    component: _450a5071,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsNaturalBeige___nl"
  }, {
    path: "/wedding-rings/polar/",
    component: _5a028310,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsPolar___nl"
  }, {
    path: "/about-acredo/sustainability/plant-my-tree/",
    component: _3586822f,
    pathToRegexpOptions: {"strict":true},
    name: "aboutPlantMyTree___nl"
  }, {
    path: "/en/about-acredo/design/",
    component: _32c27098,
    pathToRegexpOptions: {"strict":true},
    name: "aboutDesign___en"
  }, {
    path: "/en/about-acredo/jewelry-production/",
    component: _6572820a,
    pathToRegexpOptions: {"strict":true},
    name: "aboutJewelryManufacturing___en"
  }, {
    path: "/en/about-acredo/packaging/",
    component: _02d8a97d,
    pathToRegexpOptions: {"strict":true},
    name: "aboutPackaging___en"
  }, {
    path: "/en/about-acredo/philosophy/",
    component: _623b9632,
    pathToRegexpOptions: {"strict":true},
    name: "aboutPhilosophy___en"
  }, {
    path: "/en/about-acredo/quality/",
    component: _044bc579,
    pathToRegexpOptions: {"strict":true},
    name: "aboutQuality___en"
  }, {
    path: "/en/about-acredo/rjc-certification/",
    component: _04ccc8a5,
    pathToRegexpOptions: {"strict":true},
    name: "aboutRjc___en"
  }, {
    path: "/en/about-acredo/service/",
    component: _9a8dffa2,
    pathToRegexpOptions: {"strict":true},
    name: "aboutService___en"
  }, {
    path: "/en/about-acredo/sustainability/",
    component: _eb803dc6,
    pathToRegexpOptions: {"strict":true},
    name: "aboutSustainability___en"
  }, {
    path: "/en/about-acredo/wedding-rings-production/",
    component: _50620b20,
    pathToRegexpOptions: {"strict":true},
    name: "aboutWeddingRingManufacturing___en"
  }, {
    path: "/en/configurator/basic/",
    component: _1da5e3d0,
    pathToRegexpOptions: {"strict":true},
    name: "configuratorV2___en"
  }, {
    path: "/en/engagement-rings/025-carat/",
    component: _78291fa1,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRings025Carat___en"
  }, {
    path: "/en/engagement-rings/05-carat/",
    component: _71680249,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRings050Carat___en"
  }, {
    path: "/en/engagement-rings/07-carat/",
    component: _c99d306a,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRings070Carat___en"
  }, {
    path: "/en/engagement-rings/1-carat/",
    component: _debbac3a,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRings100Carat___en"
  }, {
    path: "/en/engagement-rings/bestseller/",
    component: _b0e7dde0,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsBestseller___en"
  }, {
    path: "/en/engagement-rings/brillant/",
    component: _65011c77,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsDiamond___en"
  }, {
    path: "/en/engagement-rings/budget-high/",
    component: _ad966998,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsBudgetHigh___en"
  }, {
    path: "/en/engagement-rings/budget-low/",
    component: _69656e9c,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsBudgetLow___en"
  }, {
    path: "/en/engagement-rings/budget-medium/",
    component: _19584507,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsBudgetMedium___en"
  }, {
    path: "/en/engagement-rings/classic/",
    component: _317b3696,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsClassic___en"
  }, {
    path: "/en/engagement-rings/collection-rings/",
    component: _61980fe8,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsCollectionRings___en"
  }, {
    path: "/en/engagement-rings/configurator/",
    component: _0a53b7a2,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsConfigurator___en"
  }, {
    path: "/en/engagement-rings/dainty/",
    component: _43cbf8d8,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsDainty___en"
  }, {
    path: "/en/engagement-rings/diamonds/",
    component: _3ece138c,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsDiamonds___en"
  }, {
    path: "/en/engagement-rings/exclusive/",
    component: _7836e3fe,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsExclusive___en"
  }, {
    path: "/en/engagement-rings/fancy/",
    component: _7b0d03a8,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsFancy___en"
  }, {
    path: "/en/engagement-rings/gold/",
    component: _6807f44d,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsGold___en"
  }, {
    path: "/en/engagement-rings/halo/",
    component: _282633ae,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsHalo___en"
  }, {
    path: "/en/engagement-rings/heart-rings/",
    component: _17af6dae,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsHeart___en"
  }, {
    path: "/en/engagement-rings/modern/",
    component: _ae2b3368,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsModern___en"
  }, {
    path: "/en/engagement-rings/platinum/",
    component: _1515bd99,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsPlatinum___en"
  }, {
    path: "/en/engagement-rings/princess/",
    component: _6cae9656,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsPrincess___en"
  }, {
    path: "/en/engagement-rings/red-gold/",
    component: _0279ad14,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsRedgold___en"
  }, {
    path: "/en/engagement-rings/rose-gold/",
    component: _94cff7c8,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsRosegold___en"
  }, {
    path: "/en/engagement-rings/signature/",
    component: _436869ca,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsSignature___en"
  }, {
    path: "/en/engagement-rings/solitaire/",
    component: _001114f9,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsSolitaire___en"
  }, {
    path: "/en/engagement-rings/vintage/",
    component: _4b3c78c9,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsVintage___en"
  }, {
    path: "/en/engagement-rings/white-gold/",
    component: _371a31ec,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsWhitegold___en"
  }, {
    path: "/en/engagment-rings/tension/",
    component: _10849445,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsTensionRing___en"
  }, {
    path: "/en/engraving/fonts/",
    component: _2f36ed5c,
    pathToRegexpOptions: {"strict":true},
    name: "engravingFonts___en"
  }, {
    path: "/en/engraving/inspiration/",
    component: _029232b8,
    pathToRegexpOptions: {"strict":true},
    name: "engravingInspiration___en"
  }, {
    path: "/en/engraving/sayings/",
    component: _5481e5ec,
    pathToRegexpOptions: {"strict":true},
    name: "engravingSayings___en"
  }, {
    path: "/en/engraving/symbols/",
    component: _2fb2b029,
    pathToRegexpOptions: {"strict":true},
    name: "engravingSymbols___en"
  }, {
    path: "/en/eternity-rings/bestseller/",
    component: _402c32cb,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsBestseller___en"
  }, {
    path: "/en/eternity-rings/budget-high/",
    component: _41d4ecef,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsBudgetHigh___en"
  }, {
    path: "/en/eternity-rings/budget-low/",
    component: _3b948397,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsBudgetLow___en"
  }, {
    path: "/en/eternity-rings/budget-medium/",
    component: _0a76e402,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsBudgetMedium___en"
  }, {
    path: "/en/eternity-rings/cheap/",
    component: _03ce4697,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsCheap___en"
  }, {
    path: "/en/eternity-rings/colored/",
    component: _7a11f38a,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsColored___en"
  }, {
    path: "/en/eternity-rings/gold/",
    component: _06328370,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsGold___en"
  }, {
    path: "/en/eternity-rings/half-summarized/",
    component: _1951f014,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsHalfSetMemories___en"
  }, {
    path: "/en/eternity-rings/platinum/",
    component: _29391214,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsPlatinum___en"
  }, {
    path: "/en/eternity-rings/redgold/",
    component: _34ac5d39,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsRedgold___en"
  }, {
    path: "/en/eternity-rings/rosegold/",
    component: _6c894ed2,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsRosegold___en"
  }, {
    path: "/en/eternity-rings/sets/",
    component: _e8fa802e,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsRingsets___en"
  }, {
    path: "/en/eternity-rings/signature/",
    component: _4e930600,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsSignature___en"
  }, {
    path: "/en/eternity-rings/till-005-carat/",
    component: _382270a5,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsSlim___en"
  }, {
    path: "/en/eternity-rings/till-010-carat/",
    component: _091b52c6,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsConfigurator___en"
  }, {
    path: "/en/eternity-rings/till-025-carat/",
    component: _342bc8e6,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsExclusive___en"
  }, {
    path: "/en/eternity-rings/wedding-rings/",
    component: _45bbda09,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsAsWeddingRings___en"
  }, {
    path: "/en/eternity-rings/white-gold/",
    component: _e6de1e1e,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsWhite___en"
  }, {
    path: "/en/jewelry/025-carat/",
    component: _fcac239e,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelry025Carat___en"
  }, {
    path: "/en/jewelry/05-carat/",
    component: _7ae8d0d9,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelry050Carat___en"
  }, {
    path: "/en/jewelry/07-carat/",
    component: _b69b934a,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelry070Carat___en"
  }, {
    path: "/en/jewelry/1-carat/",
    component: _cbba0f1a,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelry100Carat___en"
  }, {
    path: "/en/jewelry/bestseller/",
    component: _54137ba0,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryBestseller___en"
  }, {
    path: "/en/jewelry/bracelets/",
    component: _3ebfbebe,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryBracelets___en"
  }, {
    path: "/en/jewelry/budget-high/",
    component: _55bc35c4,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryBudgetHigh___en"
  }, {
    path: "/en/jewelry/budget-low/",
    component: _1c3367bc,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryBudgetLow___en"
  }, {
    path: "/en/jewelry/budget-medium/",
    component: _7ca168d2,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryBudgetMedium___en"
  }, {
    path: "/en/jewelry/collection-rings/",
    component: _48dcbf58,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryCollectionRings___en"
  }, {
    path: "/en/jewelry/configurator/",
    component: _9aaa839c,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryConfigurator___en"
  }, {
    path: "/en/jewelry/delicate-sets/",
    component: _77fd0aba,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryDelicateJewels___en"
  }, {
    path: "/en/jewelry/diamond-earrings/",
    component: _5ce91c2a,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryEarrings___en"
  }, {
    path: "/en/jewelry/diamond-necklace/",
    component: _756190c6,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryColliers___en"
  }, {
    path: "/en/jewelry/exclusive/",
    component: _2b04dd1e,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryExclusive___en"
  }, {
    path: "/en/jewelry/gold/",
    component: _3ed68add,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryGold___en"
  }, {
    path: "/en/jewelry/platin/",
    component: _1e968c29,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryPlatinum___en"
  }, {
    path: "/en/jewelry/redgold/",
    component: _555ccc84,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryRedgold___en"
  }, {
    path: "/en/jewelry/rosegold/",
    component: _81ce5aa8,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryRosegold___en"
  }, {
    path: "/en/jewelry/sets/",
    component: _1ae07a4e,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelrySets___en"
  }, {
    path: "/en/jewelry/signature/",
    component: _04e4ce8b,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelrySignature___en"
  }, {
    path: "/en/jewelry/signet/",
    component: _446cce69,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelrySignet___en"
  }, {
    path: "/en/jewelry/white-gold/",
    component: _5db3355c,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryWhitegold___en"
  }, {
    path: "/en/ringsize/calculator/",
    component: _f4a66126,
    pathToRegexpOptions: {"strict":true},
    name: "ringSizesCalculator___en"
  }, {
    path: "/en/ringsize/chart/",
    component: _72a6c69a,
    pathToRegexpOptions: {"strict":true},
    name: "ringSizesTable___en"
  }, {
    path: "/en/styles/your-individual-style/",
    component: _8c4a62c2,
    pathToRegexpOptions: {"strict":true},
    name: "stylesIndividualStyle___en"
  }, {
    path: "/en/trauringe-eheringe/schwarz/",
    component: _3cbfa6b9,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsBlack___en"
  }, {
    path: "/en/trauringe-eheringe/zertifikat/",
    component: _34e3ea5e,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsCertificate___en"
  }, {
    path: "/en/wedding-rings/bestseller/",
    component: _394ca5ce,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsBestseller___en"
  }, {
    path: "/en/wedding-rings/budget-high/",
    component: _35fb3186,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsBudgetHigh___en"
  }, {
    path: "/en/wedding-rings/budget-low/",
    component: _0270f0ee,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsBudgetLow___en"
  }, {
    path: "/en/wedding-rings/budget-medium/",
    component: _cfa1fa60,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsBudgetMedium___en"
  }, {
    path: "/en/wedding-rings/carbon/",
    component: _a857abba,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsCarbon___en"
  }, {
    path: "/en/wedding-rings/ceramic/",
    component: _6f29ad60,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsCeramic___en"
  }, {
    path: "/en/wedding-rings/cheap/",
    component: _01f51389,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsCheap___en"
  }, {
    path: "/en/wedding-rings/classic/",
    component: _291c6d4c,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsClassic___en"
  }, {
    path: "/en/wedding-rings/configurator/",
    component: _edab152a,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsConfigurator___en"
  }, {
    path: "/en/wedding-rings/crown/",
    component: _472d9371,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsCrown___en"
  }, {
    path: "/en/wedding-rings/diamonds/",
    component: _38351dd5,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsDiamonds___en"
  }, {
    path: "/en/wedding-rings/diversity/",
    component: _51847efe,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsGayLesbianCouples___en"
  }, {
    path: "/en/wedding-rings/exclusive/",
    component: _11426650,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsExclusive___en"
  }, {
    path: "/en/wedding-rings/facetes/",
    component: _11cf63df,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsFacetes___en"
  }, {
    path: "/en/wedding-rings/facetted-connections/",
    component: _24f6daf3,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsFacettedConnections___en"
  }, {
    path: "/en/wedding-rings/fancy/",
    component: _70ca7efa,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsFancy___en"
  }, {
    path: "/en/wedding-rings/forest_green/",
    component: _c222d2c0,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsForestGreen___en"
  }, {
    path: "/en/wedding-rings/frame_settings/",
    component: _5c85a0ea,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsFrameSettings___en"
  }, {
    path: "/en/wedding-rings/gold/",
    component: _05198b16,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsGold___en"
  }, {
    path: "/en/wedding-rings/hammered/",
    component: _7bd4d892,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsFinishes___en"
  }, {
    path: "/en/wedding-rings/hearts/",
    component: _339385a3,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsHearts___en"
  }, {
    path: "/en/wedding-rings/men/",
    component: _0b7b7990,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsMen___en"
  }, {
    path: "/en/wedding-rings/milgrain/",
    component: _04b7eb1a,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsMillgrif___en"
  }, {
    path: "/en/wedding-rings/modern/",
    component: _47f16ed5,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsModern___en"
  }, {
    path: "/en/wedding-rings/mokume-gane/",
    component: _4bd2dd0b,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsMokumeGane___en"
  }, {
    path: "/en/wedding-rings/morning-glow/",
    component: _681bebab,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsMorningGlow___en"
  }, {
    path: "/en/wedding-rings/natural-beige/",
    component: _450a5071,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsNaturalBeige___en"
  }, {
    path: "/en/wedding-rings/plain/",
    component: _62e51304,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsPlain___en"
  }, {
    path: "/en/wedding-rings/platinum/",
    component: _0e7cc7e2,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsPlatinum___en"
  }, {
    path: "/en/wedding-rings/polar/",
    component: _5a028310,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsPolar___en"
  }, {
    path: "/en/wedding-rings/red-gold/",
    component: _4453b5ab,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsRedgold___en"
  }, {
    path: "/en/wedding-rings/ring-sets/",
    component: _74a0d9d7,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsRingSets___en"
  }, {
    path: "/en/wedding-rings/rose-gold/",
    component: _a201e336,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsRosegold___en"
  }, {
    path: "/en/wedding-rings/secret-heart/",
    component: _32ff2130,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsSecretHeart___en"
  }, {
    path: "/en/wedding-rings/signature/",
    component: _11c609f2,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsSignature___en"
  }, {
    path: "/en/wedding-rings/slim/",
    component: _40553d73,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsSlim___en"
  }, {
    path: "/en/wedding-rings/stacking-rings/",
    component: _6da2287a,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStackingRings___en"
  }, {
    path: "/en/wedding-rings/starry_skies/",
    component: _ee91f8fc,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStarrySky___en"
  }, {
    path: "/en/wedding-rings/tension/",
    component: _fadf5972,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsTensionRings___en"
  }, {
    path: "/en/wedding-rings/trisets/",
    component: _33ce4c56,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingstrisets___en"
  }, {
    path: "/en/wedding-rings/two_colors/",
    component: _aa377bd4,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsTwoColors___en"
  }, {
    path: "/en/wedding-rings/wave/",
    component: _7058aacd,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsWaveDesign___en"
  }, {
    path: "/en/wedding-rings/white-gold/",
    component: _6a9470c3,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsWhitegold___en"
  }, {
    path: "/en/wedding-rings/women/",
    component: _1c5f0738,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsWomen___en"
  }, {
    path: "/en/zweiklang/configurator/",
    component: _651b55f6,
    pathToRegexpOptions: {"strict":true},
    name: "zweiklangConfigurator___en"
  }, {
    path: "/juwelen/presenteert/jaarlijks/",
    component: _36e702ff,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryPresentsYearly___nl"
  }, {
    path: "/juwelen/presenteert/kerstmis/",
    component: _4ec8fdc6,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryPresentsChristmas___nl"
  }, {
    path: "/juwelen/presenteert/moederdag/",
    component: _26857eb8,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryPresentsMother___nl"
  }, {
    path: "/juwelen/presenteert/valentijnsdag/",
    component: _64722111,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryPresentsValentine___nl"
  }, {
    path: "/juwelen/presenteert/vrouwen/",
    component: _3c1b1119,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryPresentsWomen___nl"
  }, {
    path: "/trouwringen/styles/cool/",
    component: _2fde0a01,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStylesCool___nl"
  }, {
    path: "/trouwringen/styles/creatief/",
    component: _2c62d767,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStylesCreative___nl"
  }, {
    path: "/trouwringen/styles/elegant/",
    component: _56dac0b6,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStylesElegant___nl"
  }, {
    path: "/trouwringen/styles/luxe/",
    component: _906cb876,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStylesLuxury___nl"
  }, {
    path: "/trouwringen/styles/natuurlijk/",
    component: _428b54be,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStylesNatural___nl"
  }, {
    path: "/trouwringen/styles/romantic/",
    component: _43bb4829,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStylesRomantic___nl"
  }, {
    path: "/trouwringen/styles/urban/",
    component: _9d75356c,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStylesUrban___nl"
  }, {
    path: "/en/about-acredo/sustainability/plant-my-tree/",
    component: _3586822f,
    pathToRegexpOptions: {"strict":true},
    name: "aboutPlantMyTree___en"
  }, {
    path: "/en/jewelry/presents/christmas/",
    component: _4ec8fdc6,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryPresentsChristmas___en"
  }, {
    path: "/en/jewelry/presents/forher/",
    component: _3c1b1119,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryPresentsWomen___en"
  }, {
    path: "/en/jewelry/presents/motherday/",
    component: _26857eb8,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryPresentsMother___en"
  }, {
    path: "/en/jewelry/presents/valentinesday/",
    component: _64722111,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryPresentsValentine___en"
  }, {
    path: "/en/jewelry/presents/yearly/",
    component: _36e702ff,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryPresentsYearly___en"
  }, {
    path: "/en/wedding-rings/styles/cool/",
    component: _2fde0a01,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStylesCool___en"
  }, {
    path: "/en/wedding-rings/styles/creative/",
    component: _2c62d767,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStylesCreative___en"
  }, {
    path: "/en/wedding-rings/styles/elegant/",
    component: _56dac0b6,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStylesElegant___en"
  }, {
    path: "/en/wedding-rings/styles/luxury/",
    component: _906cb876,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStylesLuxury___en"
  }, {
    path: "/en/wedding-rings/styles/natural/",
    component: _428b54be,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStylesNatural___en"
  }, {
    path: "/en/wedding-rings/styles/romantic/",
    component: _43bb4829,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStylesRomantic___en"
  }, {
    path: "/en/wedding-rings/styles/urban/",
    component: _9d75356c,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStylesUrban___en"
  }, {
    path: "/",
    component: _08271a1b,
    pathToRegexpOptions: {"strict":true},
    name: "index___nl"
  }, {
    path: "/en/article/:set/",
    component: _f844d58a,
    pathToRegexpOptions: {"strict":true},
    name: "item___en"
  }, {
    path: "/en/location/:town/",
    component: _74184f26,
    pathToRegexpOptions: {"strict":true},
    name: "shopsDetails___en"
  }, {
    path: "/en/login/:shopid/",
    component: _3d323f8a,
    pathToRegexpOptions: {"strict":true},
    name: "shoplogin___en"
  }, {
    path: "/en/wishlist/:wishlistHash/",
    component: _252755c5,
    pathToRegexpOptions: {"strict":true},
    name: "wishlistDetails___en"
  }, {
    path: "/article/:set/",
    component: _f844d58a,
    pathToRegexpOptions: {"strict":true},
    name: "item___nl"
  }, {
    path: "/locatie/:town/",
    component: _74184f26,
    pathToRegexpOptions: {"strict":true},
    name: "shopsDetails___nl"
  }, {
    path: "/login/:shopid/",
    component: _3d323f8a,
    pathToRegexpOptions: {"strict":true},
    name: "shoplogin___nl"
  }, {
    path: "/verlanglijstje/:wishlistHash/",
    component: _252755c5,
    pathToRegexpOptions: {"strict":true},
    name: "wishlistDetails___nl"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
